import DocumentPage from "../../../../invoice/DocumentPage";
import { franceRegularInvoiceConfig } from "./config";

const FranceRegularInvoice = () => (
  <DocumentPage config={franceRegularInvoiceConfig} />
);

export default FranceRegularInvoice;